import { useIntl } from "react-intl";
import { useQuery } from "react-query";

import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import {
  ListRequestOfBaseFilter,
  ListResponseOfSkuFormat,
  SkuFormat,
} from "services/KnowfullyAdminClient";

type SelectSkuFormatProps = Omit<
  AutocompleteWithQueryProps<SkuFormat>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectSkuFormat = (props: SelectSkuFormatProps) => {
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const fetchedSkuFormats = useQuery<ListResponseOfSkuFormat>(
    ["skuFormats"],
    () =>
      skuService.getSkuFormats(
        ListRequestOfBaseFilter.fromJS({
          sortField: "name",
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedSkuFormats}
      failMessage={t({ id: "selectSkuFormatFetchFailed" })}
    />
  );
};

export default SelectSkuFormat;
